import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import { ParagraphSmall, H3, Link } from "components/text"

import bgHeader from "assets/backgrounds/byp-header.png"
import bgHeaderM from "assets/backgrounds/byp-header-m.png"

const Container = styled(Flex)`
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background: url(${bgHeaderM});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    background: url(${bgHeader});
    background-size: cover;
  }
`

const LinkFlex = styled(Link)`
  display: flex;
  align-items: center;
`

const LinkText = styled(ParagraphSmall)`
  display: inline;
  font-size: 0.875rem;
  text-decoration-line: underline;
`

export const TooltipIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="white" />
    <path
      d="M11.0125 5.94C11.0125 4.572 9.9085 3.444 8.1805 3.444C6.5965 3.444 5.5045 4.572 5.5045 5.94V6.072C5.5045 6.108 5.5285 6.132 5.5645 6.132H6.8605C6.8965 6.132 6.9205 6.108 6.9205 6.072V5.94C6.9205 5.376 7.3885 4.872 8.1805 4.872C9.1045 4.872 9.5725 5.376 9.5725 5.94C9.5725 6.372 9.4525 6.624 8.4445 7.14C7.8565 7.44 7.5205 7.812 7.5205 8.856V9.384C7.5205 9.42 7.5445 9.444 7.5685 9.444H8.9005C8.9365 9.444 8.9605 9.42 8.9605 9.384V8.856C8.9605 8.664 8.9605 8.436 9.2125 8.28C10.3045 7.596 11.0125 7.404 11.0125 5.94ZM7.2805 11.94C7.2805 11.976 7.3045 12 7.3405 12H9.1525C9.1885 12 9.2125 11.976 9.2125 11.94V10.116C9.2125 10.08 9.1885 10.056 9.1525 10.056H7.3405C7.3045 10.056 7.2805 10.08 7.2805 10.116V11.94Z"
      fill="#032B24"
    />
  </svg>
)

const BYPHeader: React.FC = () => (
  <Container color="white">
    <H3 mt={[6, null, 7]} mb={[2, null, 1]}>
      Build your treatment plan
    </H3>
    <Box mb={[6, null, "5.375rem"]}>
      {/* TODO: add pathname */}
      <LinkFlex to="">
        <TooltipIcon />
        <LinkText bold ml={1}>
          How it works
        </LinkText>
      </LinkFlex>
    </Box>
  </Container>
)

export default BYPHeader
